import { useBookingModuleStoreActions } from "PFApp/booking/store";
import { useThresholds as useAccountThresholds } from "PFCore/hooks/queries/bookings/thresholds/use_thresholds";
import { useEffect } from "react";

export const useThresholds = () => {
  const thresholds = useAccountThresholds(["utilization", "overbooking"]);

  const { setThresholds } = useBookingModuleStoreActions();

  useEffect(() => {
    setThresholds(thresholds);
  }, [thresholds]);
};
